export default __webpack_public_path__ + "static/media/Punto_12_Cantina_Palio_Marinaro_ENG_Def.49774fdd.aac";